<template>
  <div class="inputFields">
    <sc-warehouses-list
      v-if="is_per_warehouse"
      ref="warehouseListComponent"
      :hasConfiguration="false"
    />

    <div class="mainContent__inputs" v-if="formFields">
      <div class="mainContent__validatedFields">
        <div
          v-for="field in validatedFields"
          :key="field.name"
          class="mainContent__input"
        >
          <div>
            <sc-tooltip
              type="is-light"
              position="is-right"
              :label="field.tooltip"
            >
              <sc-icon size="is-small" icon="info-circle" />
            </sc-tooltip>

            <label :for="field.name">
              <strong>{{ field.title }}</strong>
            </label>
          </div>
          <sc-field
          :message="(field.required && !formFields[field.name] && alreadyChecked)  ? 'O campo é obrigatório.' : ''"
          :type="(field.required && !formFields[field.name] && alreadyChecked) ? 'is-danger' : ''"
          >
            <sc-input
              :type="field.type"
              v-model="formFields[field.name]"
              :disabled="formFields.validated"
            ></sc-input>
          </sc-field>
        </div>
        <sc-button text="Validar" theme="primary" @click="onClickValidate()" :disabled="formFields.validated" />
      </div>
      <div
        v-for="field in conditionalFields"
        :key="field.name"
        class="mainContent__input"
      >
        <div>
          <sc-tooltip
            type="is-light"
            position="is-right"
            :label="field.tooltip"
          >
            <sc-icon size="is-small" icon="info-circle" />
          </sc-tooltip>

          <label :for="field.name">
            <strong>{{ field.title }}</strong>
          </label>
        </div>
        <sc-field
        :message="(field.required && !formFields[field.name] && alreadyChecked)  ? 'O campo é obrigatório.' : ''"
        :type="(field.required && !formFields[field.name] && alreadyChecked) ? 'is-danger' : ''"
        >
          <sc-input
            :type="field.type"
            v-model="formFields[field.name]"
            :disabled="!formFields.validated"
          ></sc-input>
        </sc-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScField,
  ScInput,
  ScTooltip,
  ScIcon,
  ScToast,
} from '@intelipost-js/secure-components';
import ScWarehousesList from '../sc-warehouses-list/ScWarehousesList.vue';

const { mapMutations, mapActions, mapState } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'input-fields',
  props: {
    schemaBased: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      is_per_warehouse: false,
      validatedFields: [],
      conditionalFields: [],
      alreadyChecked: false,
      formFields: null,
      isValidated: false,
      currentWarehouseId: null,
      per_warehouse: [],
    };
  },
  computed: {
    ...mapState(['appDetails']),
  },
  mounted() {
    this.is_per_warehouse = JSON.parse(
      this.appDetails.app.schemaBased,
    ).is_per_warehouse;

    this.initializeFields();
  },
  methods: {
    ...mapMutations(['nextStep', 'toggleLoading']),
    ...mapActions(['validateApp']),

    initializeFields() {
      this.validatedFields = this.schemaBased.fields.filter(
        field => !field.is_conditional,
      );

      this.conditionalFields = this.schemaBased.fields.filter(
        field => field.is_conditional,
      );

      if (this.is_per_warehouse) {
        this.$root.$on('select-warehouse', warehouse =>
          this.onSelectWarehouse(warehouse),
        );
        this.$root.$on('remove-warehouse', warehouse =>
          this.onRemoveWarehouse(warehouse),
        );
        this.$root.$on('add-warehouse', warehouse =>
          this.onAddWarehouse(warehouse),
        );
      } else {
        this.formFields = {};
      }
    },

    refreshForm() {
      const oldFormFields = this.formFields;
      this.formFields = null;
      this.formFields = oldFormFields;
    },

    async onClickValidate() {
      for (const field of this.validatedFields) {
        if (field.required && !this.formFields[field.name]) {
          this.alreadyChecked = true;
          return;
        }
      }

      const args = {
        app_id: this.$router.history.current.params.id,
        app_config: this.formFields,
      };

      this.toggleLoading(true);

      const response = await this.validateApp(args);
      this.toggleLoading(false);


      if (response.ok) {
        this.formFields.validated = true;
        this.refreshForm();
      } else {
        ScToast.open({
          message: response.message,
          duration: 20000,
          type: 'is-danger',
        });
      }
    },

    onRemoveWarehouse(warehouse) {
      this.per_warehouse = this.per_warehouse
        .filter(warehouseConfig => warehouseConfig.warehouse_id !== warehouse.id);
      this.formFields = null;
    },

    onAddWarehouse(warehouse) {
      const TRANSFORMED_FEDERAL_TAX_PAYER_ID = warehouse.federal_tax_payer_id.replace(/\D/g, '');

      this.per_warehouse.push({
        warehouse_id: warehouse.id,
        cpnj_rem: TRANSFORMED_FEDERAL_TAX_PAYER_ID,
      });
    },
    onSelectWarehouse(warehouse) {
      this.formFields = this.per_warehouse
        .find(warehouseConfig => warehouseConfig.warehouse_id === warehouse.id);
    },

    validateConfig(config) {
      if (!config.validated) {
        ScToast.open({
          message: 'Valide as credenciais antes de prosseguir',
          duration: 10000,
          type: 'is-danger',
        });
        return false;
      }
      for (const field of this.schemaBased.fields) {
        if (field.required && !config[field.name]) {
          return false;
        }
      }
      return true;
    },
  },
  components: {
    ScButton,
    ScField,
    ScInput,
    ScTooltip,
    ScIcon,
    ScToast,
    ScWarehousesList,
  },
};
</script>

<style lang="scss" scoped>
.inputFields {
  display: flex;
  gap: 40px;
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/input-fields/InputFields.vue?9944d42a